import { IClientBonCommandeModel, IClientBonLivraisonModel, IClientPropalPeriodeModel } from "@common-models/*"
import React, { useState } from "react"
import GlobalHelper from "@common-helpers/GlobalHelper"
import MyTooltip from "@common-utils/MyTooltip"
import PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsLivraison from "./_PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsLivraison"
import PtfPeriodeAddBonCommandeForm from "../actions/_PtfPeriodeAddBonCommandeForm"
import MyModal from "@common-utils/MyModal"
import { IGetPeriodesBonsCommandeBonsLivraisonResponseModel } from "../core/_models"
import { usePtfDetailsPeriodesBonsCommandeBonsLivraisonContext } from "./_PtfDetailsPeriodesBonsCommandeBonsLivraison"
import { useQueryClient } from "react-query"
import PtfPeriodeBonCommandeAddBonLivraisonForm from "../actions/_PtfPeriodeBonCommandeAddBonLivraisonForm"
import PtfPeriodeBonCommandeAddLivrableForm from "../actions/_PtfPeriodeBonCommandeAddLivrableForm"
import { deleteBonCommandeRequest } from "../core/_requests"
import { toast } from "react-toastify"
import useSwal from "@common-hooks/useSwal"
import PtfPeriodeBonCommandeEditForm from "../actions/_PtfPeriodeBonCommandeEditForm"
import MyGoogleDriveFileViewerInModal from "../../../../components/MyDocumentViewer/MyGoogleDriveFileViewerInModal"

const PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommande = ({ periode, ptf_type }: IPtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommandePropsModel) => {
     const context = usePtfDetailsPeriodesBonsCommandeBonsLivraisonContext()
     const queryClient = useQueryClient()
     const { swal } = useSwal()

     const [currentBonCommandeInModal, setCurrentBonCommandeInModal] = useState<{
          bc: IClientBonCommandeModel
          loading: boolean
     }>()
     const [editBonCommandeInModal, setEditBonCommandeInModal] = useState<IClientBonCommandeModel>()

     const [isAddBonCommandeModalShown, setIsAddBonCommandeModalShown] = useState<boolean>(false)
     const [addBonLivraisonToBonCommandeModal, setAddBonLivraisonToBonCommandeModal] = useState<{ bc: IClientBonCommandeModel }>()

     function handleSubmitAddBonCommandeCallback(val: IClientBonCommandeModel) {
          queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
               context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
               (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                    if (prev?.data) {
                         prev.data.map(item => {
                              item.clientPropalPeriodes?.map(item_ => {
                                   if (item_.id === periode.id) {
                                        item_.clientBonCommandes = [val, ...(item_.clientBonCommandes || [])]
                                        return item_
                                   }
                              })
                         })
                         return prev
                    }
                    return prev
               }
          )

          setIsAddBonCommandeModalShown(false)
     }

     function handleSubmitAddBonLivraisonCallback(val: IClientBonLivraisonModel, livraisonTotale?: boolean) {
          queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
               context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
               (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                    if (prev?.data) {
                         prev.data.map(item => {
                              item.clientPropalPeriodes?.map(item_ => {
                                   item_.clientBonCommandes?.map(item__ => {
                                        if (item__.id === addBonLivraisonToBonCommandeModal?.bc.id) {
                                             item__.clientBonLivraisons = [...(item__.clientBonLivraisons || []), val]
                                             return item__
                                        }
                                   })
                              })
                         })
                         return prev
                    }
                    return prev
               }
          )
          context.handleSubmitAddBonLivraisonCallback(val, livraisonTotale)
          setAddBonLivraisonToBonCommandeModal(undefined)
     }

     function handleRemoveBonCommande(id: number) {
          swal.fire({
               icon: "warning",
               text: `Voulez-vous vraiment supprimer le bon de commande ?`,
               showCancelButton: true,
               confirmButtonText: "Oui",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    return deleteBonCommandeRequest(id)
                         .then(() => {
                              queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
                                   context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
                                   (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                                        if (prev?.data) {
                                             prev.data.map(item => {
                                                  item.clientPropalPeriodes?.map(item_ => {
                                                       item_.clientBonCommandes?.map(item__ => {
                                                            if (item__.id === id) {
                                                                 item_.clientBonCommandes = item_.clientBonCommandes?.filter(item___ => item___.id !== id)
                                                            }
                                                       })
                                                       return item_
                                                  })
                                             })
                                             return prev
                                        }
                                        return prev
                                   }
                              )
                              toast.info("Le bon de commande a bien été supprimé")
                         })
                         .catch(e => {
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !swal.isLoading(),
          }).then()
     }

     function handleSubmitEditBonCommandeCallback(val: IClientBonCommandeModel) {
          queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
               context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
               (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                    if (prev?.data) {
                         prev.data.map(item => {
                              item.clientPropalPeriodes?.map(item_ => {
                                   item_.clientBonCommandes!.map((item__, index__) => {
                                        if (item__.id === editBonCommandeInModal?.id) {
                                             item_.clientBonCommandes![index__] = {
                                                  ...item_.clientBonCommandes![index__],
                                                  ...val,
                                             }
                                        }
                                   })
                                   return item_
                              })
                         })
                    }
                    return prev
               }
          )
          setEditBonCommandeInModal(undefined)
     }

     return (
          <div className="mt-8">
               <div className="d-flex justify-content-between align-items-center mb-6">
                    <h3 className="fs-5 fw-bold text-gray-800 m-0 d-flex align-items-center">
                         <span className="bullet bullet-vertical h-20px bg-primary me-3"></span>
                         Bons de commande
                    </h3>
                    <button className="btn btn-sm btn-light-primary fw-bold hover-scale" onClick={() => setIsAddBonCommandeModalShown(true)}>
                         <i className="fas fa-plus fs-5 me-1" /> Ajouter un BC
                    </button>
               </div>

               {periode.clientBonCommandes?.length === 0 && (
                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-6">
                         <i className="fas fa-info-circle fs-2tx text-primary me-4"></i>
                         <div className="d-flex flex-stack flex-grow-1">
                              <div className="fw-bold">
                                   <h4 className="text-gray-900 fw-bolder">Pas de Bon de Commande</h4>
                                   <div className="fs-6 text-gray-700">Aucun bon de commande n'a été créé pour cette période.</div>
                              </div>
                         </div>
                    </div>
               )}

               {periode.clientBonCommandes?.map((bonCommande, bc_key) => (
                    <div className="card card-flush border border-gray-300 mb-6 shadow-xs" key={bc_key}>
                         <div className="card-header min-h-50px px-5 bg-light-primary bg-opacity-10 border-bottom border-gray-200">
                              <div
                                   className="card-title d-flex align-items-center cursor-pointer py-3"
                                   onClick={() => setCurrentBonCommandeInModal({ bc: bonCommande, loading: true })}
                              >
                                   <div className="symbol symbol-35px me-4">
                                        <div className="symbol-label bg-white border border-gray-300 shadow-sm">
                                             <i className="fas fa-file-contract fs-4 text-primary" />
                                        </div>
                                   </div>
                                   <div className="d-flex flex-column">
                                        <div className="fs-6 fw-bolder text-gray-800 hover-primary mb-1">{bonCommande.typeLabel}</div>
                                        <span className="fs-8 fw-bold text-muted">
                                             Validité:{" "}
                                             <span className="text-gray-700">
                                                  {GlobalHelper.firstLetterUppercase(bonCommande.dateDebutValidite?.format("D MMM YYYY"))} -{" "}
                                                  {bonCommande.dateFinValidite?.format("D MMM YYYY")}
                                             </span>
                                        </span>
                                   </div>
                              </div>
                              <div className="card-toolbar gap-2">
                                   <MyTooltip title={ptf_type === "TYPE_FORFAIT" ? "Ajouter un livrable" : "Ajouter un bon de livraison"}>
                                        <button
                                             className="btn btn-sm btn-light btn-active-light-warning text-gray-600 text-hover-warning fw-bold border border-gray-300 border-dotted"
                                             onClick={() => setAddBonLivraisonToBonCommandeModal({ bc: bonCommande })}
                                        >
                                             <i className="fas fa-box-open fs-4 me-1" /> Ajouter BL
                                        </button>
                                   </MyTooltip>

                                   <div className="d-flex border-start border-gray-300 ps-2 ms-2 gap-1">
                                        <MyTooltip title="Modifier">
                                             <button className="btn btn-icon btn-sm btn-active-light-primary w-30px h-30px" onClick={() => setEditBonCommandeInModal(bonCommande)}>
                                                  <i className="fas fa-pencil-alt fs-5" />
                                             </button>
                                        </MyTooltip>
                                        <MyTooltip title="Supprimer">
                                             <button
                                                  className="btn btn-icon btn-sm btn-active-light-danger w-30px h-30px"
                                                  onClick={() => handleRemoveBonCommande(bonCommande.id as number)}
                                             >
                                                  <i className="fas fa-trash fs-5" />
                                             </button>
                                        </MyTooltip>
                                   </div>
                              </div>
                         </div>

                         <div className="card-body px-5 py-5">
                              <PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsLivraison bonCommande={bonCommande} ptf_type={ptf_type} />
                         </div>
                    </div>
               ))}

               {/* Modals */}
               {isAddBonCommandeModalShown && (
                    <MyModal
                         title={<span>{periode.reference} - Ajout d'un bon de commande</span>}
                         show={true}
                         onCloseCallback={() => setIsAddBonCommandeModalShown(false)}
                         size={"lg"}
                    >
                         <PtfPeriodeAddBonCommandeForm ptf_periode_ID={periode.id as number} handleSubmitCallback={handleSubmitAddBonCommandeCallback} />
                    </MyModal>
               )}

               {addBonLivraisonToBonCommandeModal && (
                    <MyModal
                         title={
                              <span>
                                   {periode.reference} - Ajout d'un {ptf_type === "TYPE_ASSISTANCE_TECHNIQUE" ? "bon de livraison" : "livrable"}
                              </span>
                         }
                         show={true}
                         onCloseCallback={() => setAddBonLivraisonToBonCommandeModal(undefined)}
                         size={"xl"}
                    >
                         {ptf_type === "TYPE_ASSISTANCE_TECHNIQUE" ? (
                              <PtfPeriodeBonCommandeAddBonLivraisonForm
                                   bc_ID={addBonLivraisonToBonCommandeModal.bc!.id as number}
                                   handleSubmitCallback={handleSubmitAddBonLivraisonCallback}
                              />
                         ) : (
                              <PtfPeriodeBonCommandeAddLivrableForm
                                   bc_ID={addBonLivraisonToBonCommandeModal.bc!.id as number}
                                   handleSubmitCallback={handleSubmitAddBonLivraisonCallback}
                              />
                         )}
                    </MyModal>
               )}

               {currentBonCommandeInModal && (
                    <MyGoogleDriveFileViewerInModal
                         googleDriveID={currentBonCommandeInModal.bc.googleDriveID as string}
                         googleDriveMimetype={currentBonCommandeInModal.bc.googleDriveMimeType as string}
                         modalTitle={<>{currentBonCommandeInModal.bc.typeLabel}</>}
                         handleCloseModal={() => setCurrentBonCommandeInModal(undefined)}
                         modalSize={"xl"}
                    />
               )}

               {editBonCommandeInModal && (
                    <MyModal
                         title={
                              <>
                                   Bon de commande du {editBonCommandeInModal.dateDebutValidite?.format("D MMM YYYY")} au{" "}
                                   {editBonCommandeInModal.dateFinValidite?.format("D MMM YYYY")}
                              </>
                         }
                         show={true}
                         onCloseCallback={() => setEditBonCommandeInModal(undefined)}
                         size={"lg"}
                    >
                         <PtfPeriodeBonCommandeEditForm bc={editBonCommandeInModal} handleSubmitCallback={handleSubmitEditBonCommandeCallback} />
                    </MyModal>
               )}
          </div>
     )
}

interface IPtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommandePropsModel {
     periode: IClientPropalPeriodeModel
     ptf_type: "TYPE_FORFAIT" | "TYPE_ASSISTANCE_TECHNIQUE" | string
}

export default PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommande
